import $ from 'jquery';
window.$ = $;


/*
 * popup
 */
//import('./_popup.js');
import 'remodal';

$('a[href^="#inline_"]').on('click', function (e) {
	e.preventDefault();

	const modalId = $(this).attr('href').slice(1);
	const targetModal = $('[data-remodal-id="' + modalId + '"]').remodal();
	targetModal.open();
});



/*
 * スライダー
 */
import './_swiper.js';


/*
 * スムーススクロール
 */
import './_smoothScroll.js';



/*
 * ビデオモーダル
 */
import ModalVideo from 'modal-video';

/* Modal Video */
new ModalVideo('.movie-kids', {channel: 'custom',url: '/wp/wp-content/uploads/movie/movie_kids_short.mp4'});
new ModalVideo('.movie-kids-long', {channel: 'custom',url: '/wp/wp-content/uploads/movie/movie_kids_long.mp4'});
new ModalVideo('.movie-kids-nijiiro', {channel: 'youtube'});



/*
 * details > summaryのテキスト変更
 */
import './_accordion.js';

